export enum DepositInstructionsKey {
  GLOBAL = 'global',
  MINIMUM_DEPOSIT = 'minimumDeposit',
  PROCESSING_TIME = 'processingTime',
}

export interface DepositInstructionsType {
  key: DepositInstructionsKey
  iconName: string
  descriptionTranslateFirstKey: string
  descriptionTranslateSecondKey?: string
}

export const depositInstructions: DepositInstructionsType[] = [
  {
    key: DepositInstructionsKey.GLOBAL,
    iconName: 'global',
    descriptionTranslateFirstKey: 'translation:theCorrectNetworkMessage',
  },
  {
    key: DepositInstructionsKey.MINIMUM_DEPOSIT,
    iconName: 'interest',
    descriptionTranslateFirstKey: 'translation:minimumDepositIs',
    descriptionTranslateSecondKey: 'translation:depositsBellowThisAmount',
  },
  {
    key: DepositInstructionsKey.PROCESSING_TIME,
    iconName: 'clock',
    descriptionTranslateFirstKey: 'translation:networkDetails.processingTime',
    descriptionTranslateSecondKey: 'translation:minutes',
  },
]
